import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled'
import image from './cryptomonedas.png';
import Form from './components/Form'
import Quotation from './components/Quotation'
import axios from 'axios';
import Spinner from './components/Spinner'
/**Styles */
const Container = styled.div`
  max-width:900px;
  margin:0 auto; 
  @media (min-width:992px){
    display:grid;
    grid-template-columns:repeat(3, 1fr);
    column-gap:3rem;
  }
`;

const Imagen = styled.img`
  max-width:100%;
  margin-top:5rem;
`;

const Heading = styled.h1`
  font-family:'Bebas Neue',cursive;
  color:#FFF;
  text-align:left;
  font-weight:700;
  font-size:50px;
  margin-bottom:50px;
  margin-top:80px;
  
  &::after {
    content:'';
    width:100px;
    height:6px;
    background-color:#66A2FE;
    display:block;
  }
`;


/**Component */
function App() {

  const [currency, saveCurrency] = useState('');
  const [cryptoCurrency, saveCryptoCurrency] = useState('');
  const [result, setResult] = useState({});
  const [loading, saveLoading] = useState(false);

  useEffect(() => {
    const quoteCryptocurrencies = async () => {
      //evitamos la ejecucion la primera vez o se piede crear la funcion
      if (currency === '') return;
      console.log("cotizando");

      // consultar la api para obtener la cotizacion
      const url = `https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${cryptoCurrency}&tsyms=${currency}`;

      const result = await axios.get(url);

      //mostrar el spinner
      saveLoading(true);
      setTimeout(() => {

        saveLoading(false);
        setResult(result.data.DISPLAY[cryptoCurrency][currency]);

      }, 2000);
    }
    quoteCryptocurrencies();
  }, [currency, cryptoCurrency]);

  //Mostrar spinner o resultado
  const component = (loading) ? <Spinner /> : <Quotation result={result} />;

  return (
    <Container>
      <div>
        <Heading>
          Cotiza criptomonedas al instante
        </Heading>
        <Form
          saveCurrency={saveCurrency}
          saveCryptoCurrency={saveCryptoCurrency}
        />
      </div>
      <div>
        <Imagen
          src={image}
          alt="imagen cripto"
        />
      </div>
        {component}
      <div>
      </div>
    </Container>
  );
}

export default App;
